import React, { Component } from "react"
import { connect } from "react-redux"

import { selectDevice } from "./../../redux/actions/basket-actions"
import { nextPage, prevPage } from "./../../redux/actions/journey-actions"
import { getAllDevicesSelector } from "../../redux/selectors/device-selector"
import DeviceList from "../../components/choose-device/device-list"
import "./select-device-page.scss"
class SelectDevicePage extends Component {
  componentDidMount() {
    let hideMenu = document.getElementsByClassName("menuItem")
    let hideEntertainment = Array.prototype.find.call(
      hideMenu,
      elem => elem.innerText === "Add Entertainment"
    )
    if (hideEntertainment) {
      hideEntertainment.hidden = true
    }
  }

  handleSelectDevice(id) {
    this.props.selectDevice(id)
    this.props.gotoNextPage()
  }

  render() {
    const { gotoPrevPage, devices, excludeVAT } = this.props

    return (
      <>
        <DeviceList
          devices={devices}
          onSelect={id => this.handleSelectDevice(id)}
          excludeVAT={excludeVAT}
        />
        <div className="back-button-container">
          <button className="back-button" onClick={gotoPrevPage}>
            Back
          </button>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  devices: getAllDevicesSelector(state),
  excludeVAT: state.plans.options.excludeVAT
})

const mapDispatchToProps = dispatch => ({
  selectDevice: id => dispatch(selectDevice(id)),
  gotoNextPage: () => dispatch(nextPage()),
  gotoPrevPage: () => dispatch(prevPage())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectDevicePage)
